<template>
  <v-form>
    <v-autocomplete
      v-model="form.subjectId"
      label="Matéria"
      :items="subjects"
      item-text="name"
      item-value="id"
    ></v-autocomplete>
    <v-text-field
      v-model="form.name"
      label="Nome"
      name="name"
      prepend-icon="mdi-alphabetical"
      type="text"
    />
    <v-subheader>Horários</v-subheader>
    <v-row>
      <v-col cols="12" sm="12">
        <v-select
          v-model="form.daysOfWeek"
          :items="items"
          item-text="text"
          item-value="value"
          prepend-icon="mdi-calendar-week"
          label="Dias da semana"
          multiple
          hide-details
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" sm="5">
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="form.startAt"
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="form.startAt"
              label="Picker in menu"
              prepend-icon="mdi-clock-start"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-time-picker
            v-if="menu"
            v-model="form.startAt"
            full-width
            @click:minute="$refs.menu.save(form.startAt)"
          ></v-time-picker>
        </v-menu>
      </v-col>
      <v-col cols="6" sm="5">
        <v-menu
          ref="menu2"
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="form.endAt"
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="form.endAt"
              label="Picker in menu2"
              prepend-icon="mdi-clock-end"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-time-picker
            v-if="menu2"
            v-model="form.endAt"
            full-width
            @click:minute="$refs.menu2.save(form.endAt)"
          ></v-time-picker>
        </v-menu>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
export default {
  props: {
    text: String,
    subjects: Array,
    defaultForm: Object
  },
  data() {
    return {
      menu: null,
      menu2: null,
      items: [
        {
          text: "Segunda",
          value: 1
        },
        {
          text: "Terça",
          value: 2
        },
        {
          text: "Quarta",
          value: 3
        },
        {
          text: "Quinta",
          value: 4
        },
        {
          text: "Sexta",
          value: 5
        },
        {
          text: "Sábado",
          value: 6
        },
        {
          text: "Doming",
          value: 7
        }
      ],
      form: {
        name: undefined,
        daysOfWeek: undefined,
        subjectId: undefined,
        startAt: null,
        endAt: null
      }
    };
  },
  watch: {},
  methods: {
  }
};
</script>
